import { buildUnsubscribeApiUrl } from './unsubscribeUrl';

/**
 * Utility to generate RFC 8058 compliant List-Unsubscribe headers.
 * These headers enable the "One-Click Unsubscribe" button in major email clients.
 */
export const generateUnsubscribeHeaders = (
  toEmail: string,
  userId?: string,
  workspaceId?: string,
  customUnsubscribeUrl?: string
): { [key: string]: string } => {
  const unsubUrl =
    customUnsubscribeUrl ||
    buildUnsubscribeApiUrl({ email: toEmail, userId, workspaceId });
  
  return {
    'List-Unsubscribe': `<${unsubUrl}>`,
    'List-Unsubscribe-Post': 'List-Unsubscribe=One-Click'
  };
};

/**
 * Checks if an email should have unsubscribe headers (i.e., it's not a system/verification email)
 */
export const shouldAddUnsubscribeHeaders = (
  subject: string = '',
  tags: { [key: string]: string } = {}
): boolean => {
  const lowerSubject = subject.toLowerCase();
  
  // Don't add to verification or password reset emails
  const isVerificationEmail = 
    lowerSubject.includes('verify') || 
    lowerSubject.includes('verification') || 
    lowerSubject.includes('password reset') || 
    lowerSubject.includes('reset your password') ||
    lowerSubject.includes('passcode');

  // Don't add to specific system types
  const isSystemEmail = 
    tags.Source === 'system' || 
    tags.Type === 'verification' || 
    tags.Type === 'password_reset' || 
    tags.Type === 'plan_activation';

  return !isVerificationEmail && !isSystemEmail;
};
